const state = {
    
    blocks:[
        {
            id:1,
            name:'',
            color:'#fff',
            columns:1,
            blockcomponents: {
                columns: [
                    //left column
                    [
                        {
                            id:1,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Name",
                                    size:"xs2",
                                    invertedsize:"xs9",
                                    hint:"Bitte den Namen eingeben",
                                    icon:"edit",
                                    variable: 'name',
                                    setter: 'units/UNIT_SET_NAME',
                                    rules:"required"                                    
                            }
                        },
                                                                      
                    ],                   
                                 
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};